<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div
            class="alert alert-danger alert-dismissible fade show p-1"
            role="alert"
            v-if="!hasUnidades"
          >
            <strong>Atenção!</strong> Nenhuma unidade foi cadastrada no sistema.
            <router-link to="/unidades/add" class="alert-link"
              >Clique aqui para cadastrar uma unidade</router-link
            >
            .
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="col-md-12">
          <div
            class="alert alert-danger alert-dismissible fade show p-1"
            role="alert"
            v-if="check_system.base_synchronization"
          >
            <strong>Atenção!</strong> A configuração "BASE_SINCRONIZACAO" não
            existe ou esta vazia, por favor configure.
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="col-md-12">
          <div
            class="alert alert-danger alert-dismissible fade show p-1"
            role="alert"
            v-if="check_system.time_delay_password"
          >
            <strong>Atenção!</strong> A configuração "TEMPO_DELAY_SENHA" não
            existe ou esta vazia, por favor configure.
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="col-md-12">
          <div
            class="alert alert-danger alert-dismissible fade show p-1"
            role="alert"
            v-if="check_system.upload_max_filesize"
          >
            <strong>Atenção!</strong> A configuração do "upload_max_filesize" é
            inválida para a operação do sistema, o ideal é >= 400.
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="col-md-12">
          <div
            class="alert alert-danger alert-dismissible fade show p-1"
            role="alert"
            v-if="check_system.post_max_size"
          >
            <strong>Atenção!</strong> A configuração do "post_max_size" é
            inválida para a operação do sistema, o ideal é >= 400.
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="col-md-12">
          <div
            class="alert alert-danger alert-dismissible fade show p-1"
            role="alert"
            v-if="check_system.max_execution_time"
          >
            <strong>Atenção!</strong> A configuração do "max_execution_time" é
            inválida para a operação do sistema, o ideal é >= 300.
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="col-md-12">
          <div
            class="alert alert-danger alert-dismissible fade show p-1"
            role="alert"
            v-if="check_system.max_input_time"
          >
            <strong>Atenção!</strong> A configuração do "max_input_time" é
            inválida para a operação do sistema, o ideal é >= 300.
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="col-md-12">
          <div
            class="alert alert-danger alert-dismissible fade show p-1"
            role="alert"
            v-if="check_system.reverb_apps_empty"
          >
            <strong>Atenção!</strong> Nenhuma aplicação Reverb cadastrada na
            tabela <code>reverb_apps</code>. O WebSocket não funcionará até
            inserir as credenciais (app_id, key, secret) desta unidade.
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
      <div class="row px-3" style="font-weight: 700">
        <div
          class="col-md-3 p-1"
          v-for="(count, index) in counter"
          :key="index"
        >
          <router-link
            class="card card-home p-1"
            style="min-height: 15vh; cursor: pointer"
            :to="count.url"
            v-if="[5, 7].includes($store.state.user.perfil_id)"
          >
            <span
              :class="
                'b-avatar badge-light-' +
                color[index % color.length] +
                ' rounded-circle'
              "
            >
              <span class="b-avatar-custom">
                <i :class="count.icons"></i>
              </span>
            </span>
            <h3 class="text-dark mt-1">
              <b>{{ count.qtd }}</b>
            </h3>
            <span class="text-secondary" style="font-size: 2vh">{{
              count.name
            }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BCardText, BLink } from "bootstrap-vue";

import { BCard, BCardBody, BAvatar } from "bootstrap-vue";

export default {
  data() {
    return {
      dashboard: [],
      counter: {},
      check_system: {},
      configuration: {},
      color: ["primary", "success", "danger", "warning"],
      hasUnidades: true, // Variável para verificar se existem unidades
    };
  },
  components: {
    BCard,
    BCardText,
    BLink,
    BCardBody,
    BAvatar,
  },
  methods: {
    counters: function () {
      const self = this;
      const api = self.$store.state.api + "counter";

      axios
        .get(api)
        .then((response) => {
          self.counter = response.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    checkSystem: function () {
      const self = this;
      const api = self.$store.state.api + "check-system";

      axios
        .get(api)
        .then((response) => {
          self.check_system = response.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getConfiguration: function () {
      const self = this;
      const cached = self.$store.state.configuracao_cache;
      if (cached) {
        self.configuration = cached.updatedAt ? cached.data : cached;
        return;
      }

      axios
        .get(self.$store.state.api + "configuracoes")
        .then((response) => {
          const config = response.data.data
            ? response.data.data[0]
            : response.data;
          self.configuration = config;
          self.$store.commit("setConfiguracaoCache", {
            data: config,
            updatedAt: Date.now(),
          });
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    checkUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades?paginated=false";

      axios
        .get(api)
        .then((response) => {
          // Verifica se existe pelo menos uma unidade
          self.hasUnidades =
            response.data.data && response.data.data.length > 0;
        })
        .catch((error) => {
          // Em caso de erro, assume que não há unidades
          self.hasUnidades = false;
          console.error("Erro ao verificar unidades:", error);
        });
    },
  },
  mounted() {
    const self = this;

    self.counters();
    self.checkSystem();
    self.getConfiguration();
    self.checkUnidades();
  },
  created() {},
};
</script>

<style>
i {
  font-size: 13pt;
}

.card-home:hover {
  box-shadow: 3px 3px #ddd;
  transform: scale(1.05);
}
</style>
